<div class="callback-container">
  <div class="callback-content">
    <!-- Processing State -->
    @if (isProcessing && !errorMessage && !successMessage) {
      <div class="state-section processing">
        <div class="spinner-wrapper">
          <div class="spinner"></div>
        </div>
        <h2 class="state-title">{{ 'AUTH.CALLBACK_PROCESSING' | translate }}</h2>
        <p class="state-text">{{ 'AUTH.CALLBACK_PROCESSING_TEXT' | translate }}</p>
      </div>
    }

    <!-- Success State -->
    @if (successMessage && !errorMessage) {
      <div class="state-section success">
        <div class="icon-wrapper success-icon">
          <i class="fa fa-check-circle"></i>
        </div>
        <h2 class="state-title">{{ successMessage }}</h2>
        <p class="state-text">{{ 'AUTH.CALLBACK_SUCCESS_TEXT' | translate }}</p>
      </div>
    }

    <!-- Error State -->
    @if (errorMessage) {
      <div class="state-section error">
        <div class="icon-wrapper error-icon">
          <i class="fa fa-exclamation-circle"></i>
        </div>
        <h2 class="state-title">{{ 'AUTH.CALLBACK_ERROR_TITLE' | translate }}</h2>
        <p class="state-text error-text">{{ errorMessage }}</p>
        <div class="action-buttons">
          <button
            class="btn btn-primary"
            (click)="onRetry()"
            type="button"
            >
            <i class="fa fa-refresh"></i> {{ 'AUTH.CALLBACK_RETRY' | translate }}
          </button>
          <button
            class="btn btn-secondary"
            (click)="onGoHome()"
            type="button"
            >
            <i class="fa fa-home"></i> {{ 'AUTH.CALLBACK_HOME' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
